import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { render } from "react-dom";
import "./index.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";

if (process.env.NODE_ENV === "production") {
  setTimeout(() => {
    var newDiv = document.createElement("div");
    newDiv.setAttribute("id", "wpglobus-switcher-root");
    newDiv.classList.add("maybe-interface-pinned-items");
    var btns: HTMLCollectionOf<Element> = document.getElementsByClassName(
      "components-button is-primary"
    );
    if (btns.length === 0) {
      return;
    }
    var existingNode: any = btns[1];
    if (existingNode.length === 0) {
      return;
    }
    existingNode.parentNode.insertBefore(newDiv, existingNode.nextSibling);

    render(
      <StrictMode>
        <App />
      </StrictMode>,
      document.getElementById("wpglobus-switcher-root")
    );
  }, 1500);
} else {
  const root = ReactDOM.createRoot(
    document.getElementById("wpglobus-switcher-root") as HTMLElement
  );
  root.render(<App />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
